var path = 'app/components/common/qrCodeScanner/qrModal.html';
var html = "<div class=\"modal-content\"><div class=\"color-line\"></div><div class=\"modal-header\"><h5 class=\"modal-title\">Title</h5></div><div class=\"modal-body\"><div class=\"hpanel stats\"><div class=\"panel-body list\"><qr-scan on-data=\"vm.onQrCode(content)\"></qr-scan></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.cancel()\">Odustani</button></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/common/qrCodeScanner/qrModal.html
// module id = 509
// module chunks = 0